import React from 'react';

export interface AnnouncementProps {}

const Announcement: React.FC<AnnouncementProps> = () => {
  return null;
};

export default Announcement;
